import { Eye, EyeSlash } from '@phosphor-icons/react'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import {
  CodeInput,
  DisabledDiv,
  InputContainer,
  Link,
  SubmitContainer,
  Text,
} from './styles'

import api from '../../../../services/api'

interface RecoverPasswordSecondStepProps {
  openModalSuccess: Dispatch<SetStateAction<boolean>>
  openModalError: Dispatch<SetStateAction<boolean>>
  openModalResendCode: Dispatch<SetStateAction<boolean>>
}

export const RecoverPasswordSecondStep = ({
  openModalSuccess,
  openModalError,
  openModalResendCode,
}: RecoverPasswordSecondStepProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const [codeInput, setCodeInput] = useState('')
  const [passwordInput, setPasswordInput] = useState('')

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    api
      .post('/v1/user/password/update', {
        password: passwordInput,
        verification_code: codeInput,
      })
      .then((response) => {
        console.log(response)
        toggleFunction(openModalSuccess)
      })
      .catch((error) => {
        console.log('Error:', error.response)
        if (error.status === 500) {
          toggleFunction(openModalError)
        } else {
          toggleFunction(openModalResendCode)
        }
      })
  }

  return (
    <InputContainer>
      <Text>
        Preencha o campos abaixo para confirmar e habilitar a criação de uma
        nova senha:
      </Text>
      <Input.Root>
        <Input.Label
          title="Insira o código recebido"
          htmlFor="code"
          color="#150D49"
        />
        <CodeInput
          id="code"
          maxLength={6}
          value={codeInput}
          onChange={(e) => {
            setCodeInput(e.target.value)
          }}
        />
      </Input.Root>
      <Link onClick={() => toggleFunction(openModalResendCode)}>
        Encaminhar novo e-mail{' '}
      </Link>
      <DisabledDiv isDisabled={codeInput.length < 6}>
        <Input.Root>
          <Input.Label
            title="Nova senha"
            htmlFor="recoverPasswordFormEmail"
            color="#150D49"
          />
          <Input.Wrapper
            borderColor="#665396"
            backgroundColor="#fff"
            outlineColor="#665396"
          >
            <Input.Content
              id="recoverPasswordFormEmail"
              placeholder="Senha"
              type={showPassword ? 'password' : 'text'}
              disabled={codeInput.length < 6}
              value={passwordInput}
              onChange={(e) => {
                setPasswordInput(e.target.value)
              }}
            />
            <Input.Icon
              padding="0 1rem"
              onClick={() => toggleFunction(setShowPassword)}
            >
              {showPassword ? (
                <EyeSlash size={16} color="#665396" />
              ) : (
                <Eye size={16} color="#665396" />
              )}
            </Input.Icon>
          </Input.Wrapper>
        </Input.Root>
      </DisabledDiv>
      <SubmitContainer>
        <Button.Root
          type="submit"
          backgroundColor="#150D49"
          onClick={handleSubmit}
          disabled={codeInput.length < 6}
        >
          <Button.Content title="Alterar senha" />
        </Button.Root>
      </SubmitContainer>
    </InputContainer>
  )
}
